(() => {
  const initialized = new WeakMap();
  const initializeTire = (root) => {
    const dataNode=root.closest('.shopify-section')?.querySelector('[data-pdl-tire-data]');
    const form=root.querySelector('[data-pdl-tire-form]');
    const rimSelect=root.querySelector('[data-pdl-tire-rim]');
    const widthSelect=root.querySelector('[data-pdl-tire-width]');
    const baseUrl=root.dataset.pdlBaseUrl;
    if(!dataNode || !form || !rimSelect || !widthSelect || !baseUrl)return;
    const previous=initialized.get(root);
    if(previous?.rimSelect===rimSelect && previous?.secondarySelect===widthSelect && previous?.form===form && rimSelect.options.length>1)return;
    previous?.controller.abort();
    const controller=new AbortController();
    const signal=controller.signal;
    let measures=JSON.parse(dataNode.textContent);
    const url=new URL(window.location.href);
    const rimParam=root.dataset.pdlRimParam;
    const activeTag=url.pathname.split('/').find(part=>part.startsWith('pdl-medida-')) || '';
    const activeMeasure=measures.find(measure=>measure.widths.some(item=>item.tag===activeTag));
    const all=root.dataset.pdlAllLabel;
    const option=(value,label)=>new Option(label,value);
    const loadWidths=(rim,tag='')=>{
      widthSelect.replaceChildren(option('',all));
      const measure=measures.find(item=>item.rim===rim);
      for(const item of measure?.widths || [])widthSelect.add(option(item.tag,item.width));
      widthSelect.disabled=!rim;
      if(tag && [...widthSelect.options].some(item=>item.value===tag))widthSelect.value=tag;
    };
    const loadRims=(rim='',tag='')=>{
      rimSelect.replaceChildren(option('',all));
      for(const measure of measures)rimSelect.add(option(measure.rim,root.dataset.pdlRimPrefix+' '+measure.rim.replace('.',',')));
      if(rim && ![...rimSelect.options].some(item=>item.value===rim))rimSelect.add(option(rim,root.dataset.pdlRimPrefix+' '+rim.replace('.',',')));
      rimSelect.value=rim;loadWidths(rim,tag);
    };
    loadRims(activeMeasure?.rim || url.searchParams.get(rimParam) || '',activeTag);
    rimSelect.addEventListener('change',()=>loadWidths(rimSelect.value),{signal});
    form.addEventListener('submit',event=>{
      event.preventDefault();
      const target=new URL(baseUrl,window.location.origin);
      if(widthSelect.value)target.pathname+='/'+widthSelect.value;
      const current=new URL(window.location.href);
      for(const [name,value] of current.searchParams)if((name.startsWith('filter.') && name!==rimParam) || name==='sort_by' || name==='preview_theme_id')target.searchParams.append(name,value);
      if(rimSelect.value)target.searchParams.set(rimParam,rimSelect.value);
      window.location.assign(target);
    },{signal});
    initialized.set(root,{rimSelect,secondarySelect:widthSelect,form,controller});
    root.dataset.ready='true';
    if(window.PDLSmartSearch)void window.PDLSmartSearch.search('pneu').then(result=>{
      if(signal.aborted || !root.isConnected)return;
      const availableTags=new Set(result.products.flatMap(product=>product.sources || [product]).flatMap(product=>product.tags || []));
      const available=measures.map(measure=>({...measure,widths:measure.widths.filter(item=>availableTags.has(item.tag) || item.tag===activeTag)})).filter(measure=>measure.widths.length);
      if(!available.length)return;
      const selectedRim=rimSelect.value,selectedWidth=widthSelect.value;
      measures=available;loadRims(selectedRim,selectedWidth);
    }).catch(()=>{});
  };

  const initializeRim=(root)=>{
    const dataNode=root.closest('.shopify-section')?.querySelector('[data-pdl-rim-data]');
    const form=root.querySelector('[data-pdl-rim-form]'),rimSelect=root.querySelector('[data-pdl-rim-size]'),holesSelect=root.querySelector('[data-pdl-rim-holes]');
    const baseUrl=root.dataset.pdlBaseUrl;
    if(!dataNode || !form || !rimSelect || !holesSelect || !baseUrl)return;
    const previous=initialized.get(root);
    if(previous?.rimSelect===rimSelect && previous?.secondarySelect===holesSelect && previous?.form===form && rimSelect.options.length>1)return;
    previous?.controller.abort();const controller=new AbortController(),signal=controller.signal;
    let measures=JSON.parse(dataNode.textContent);
    const activeTag=window.location.pathname.split('/').find(part=>part.startsWith('pdl-aro-')) || '';
    const activeMeasure=measures.find(measure=>'pdl-aro-'+measure.rim.replace('.','-')===activeTag || measure.holes.some(item=>item.tag===activeTag));
    const option=(value,label)=>new Option(label,value),all=root.dataset.pdlAllLabel;
    const loadHoles=(rim,tag='')=>{
      holesSelect.replaceChildren(option('',all));
      const measure=measures.find(item=>item.rim===rim);
      for(const item of measure?.holes || [])holesSelect.add(option(item.tag,item.holes+' '+root.dataset.pdlHolesSuffix));
      holesSelect.disabled=!rim;
      if(tag && [...holesSelect.options].some(item=>item.value===tag))holesSelect.value=tag;
    };
    const loadRims=(rim='',tag='')=>{
      rimSelect.replaceChildren(option('',all));
      for(const measure of measures)rimSelect.add(option(measure.rim,root.dataset.pdlRimPrefix+' '+measure.rim.replace('.',',')));
      rimSelect.value=rim;loadHoles(rim,tag);
    };
    loadRims(activeMeasure?.rim || '',activeTag);
    rimSelect.addEventListener('change',()=>loadHoles(rimSelect.value),{signal});
    form.addEventListener('submit',event=>{
      event.preventDefault();const target=new URL(baseUrl,window.location.origin);
      const tag=holesSelect.value || (rimSelect.value?'pdl-aro-'+rimSelect.value.replace('.','-'):'');
      if(tag)target.pathname+='/'+tag;
      for(const [name,value] of new URL(window.location.href).searchParams)if(name.startsWith('filter.') || name==='sort_by' || name==='preview_theme_id')target.searchParams.append(name,value);
      window.location.assign(target);
    },{signal});
    initialized.set(root,{rimSelect,secondarySelect:holesSelect,form,controller});root.dataset.ready='true';
    if(window.PDLSmartSearch)void window.PDLSmartSearch.search('aro').then(result=>{
      if(signal.aborted || !root.isConnected)return;
      const tags=new Set(result.products.flatMap(product=>product.sources || [product]).flatMap(product=>product.tags || []));
      const available=measures.map(measure=>({...measure,holes:measure.holes.filter(item=>tags.has(item.tag) || item.tag===activeTag)})).filter(measure=>measure.holes.length);
      if(available.length){const rim=rimSelect.value,holes=holesSelect.value;measures=available;loadRims(rim,holes);}
    }).catch(()=>{});
  };
  const selector = '[data-pdl-tire-finder], [data-pdl-rim-finder]';
  const initialize = () => {
    document.querySelectorAll('[data-pdl-tire-finder]').forEach(initializeTire);
    document.querySelectorAll('[data-pdl-rim-finder]').forEach(initializeRim);
  };
  let frame = 0;
  const schedule = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      initialize();
    });
  };
  const start = () => {
    initialize();
    new MutationObserver((records) => {
      if (records.some((record) => record.target.closest?.(selector) ||
        Array.from(record.addedNodes).some((node) => node.matches?.(selector) || node.querySelector?.(selector)))) {
        schedule();
      }
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', schedule);
    window.addEventListener('pageshow', schedule);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
